import React from 'react';
import MenuItem from '@mui/material/MenuItem';
import FormControl from "@mui/material/FormControl";
import FormHelperText from "@mui/material/FormHelperText";
import InputLabel from "@mui/material/InputLabel";
import Select from "@mui/material/Select";


export default function ArgoSelectWithRenderValueHook(props) {

    const fileName = props.fileName ?? "NoFileName";
    const fieldName = props.fieldName ?? "NoFieldName";

    const index = props.index ?? ""; // If field is built in a loop index is required to know which field to match up with

    const uniqueIdentifier = fileName + "-ArgoSelectWithRenderValueHook-" + fieldName + index;
    const uniqueIdentifierLabel = uniqueIdentifier + "-label";

    const variant = props.variant ?? "standard";
    const label = props.label ?? "";

    const width = props.width ?? "";

    const paddingBottom = props.paddingBottom ?? "0px";

    const onChange = props.onChange ?? function () {};

    const disabled = props.disabled ?? false;

    const menuItems = Array.isArray(props.menuItems)
        ? props.menuItems.filter(item => item !== undefined && item !== null)
        : [];

    const valueProperty = props.valueProperty ?? "value";
    const textProperty = props.textProperty ?? "text";

    const defaultValue = props.defaultValue ?? ""; // Default to first item in menuitem list menuItems[0][valueProperty] ????

    const findMenuItem = (selectedValue) => menuItems.find(item => item && item[valueProperty] === selectedValue);

    const handleChange = (event) => {
        const selectedValue = event.target.value;
        const selectedItem = findMenuItem(selectedValue);
        if (!selectedItem || selectedItem[textProperty] === undefined) {
            return;
        }

        const renderedText = selectedItem[textProperty];
        const title = renderedText && renderedText.props ? renderedText.props.title : renderedText;
        onChange(event, fieldName, title, index);
    };

    return (menuItems.length > 0 ?
        <FormControl variant={variant} sx={{width: width, paddingBottom: defaultValue === "" ? "7px" : paddingBottom}} disabled={disabled}>
            <InputLabel id={uniqueIdentifierLabel}>{label}</InputLabel>
            <Select
                id={uniqueIdentifier}
                name={uniqueIdentifier}
                labelId={uniqueIdentifierLabel}
                onChange={handleChange}
                defaultValue={defaultValue}
                renderValue={(selected) => {
                    const item = findMenuItem(selected);
                    return item && item[textProperty] !== undefined ? item[textProperty] : "";
                }}
            >
                {menuItems.map((item, menuIndex) => {
                    if (!item || item[valueProperty] === undefined || item[textProperty] === undefined) {
                        return null;
                    }

                    return (
                        <MenuItem key={uniqueIdentifier + menuIndex} value={item[valueProperty]}>
                            {item[textProperty]}
                        </MenuItem>
                    );
                })}
            </Select>
            <FormHelperText sx={{width: "14px"}}>&nbsp;</FormHelperText>
        </FormControl>
        :
        <div></div>
    );
}

// select property displayEmpty={true} may be needed
